import { Mesh, ShaderMaterial, Color } from 'three';

import gsap from 'gsap';

import fragmentShader from '../../../../shaders/background-frag.glsl';
import vertexShader from '../../../../shaders/background-vert.glsl';

export default class BackgroundItem extends Mesh {

	colorTo;
	colorFrom;

	constructor({ sizes, geometry }) {
		super();

		this.isAnimating = false;

		this.sizes = sizes;

		this.colors = {
			green: new Color(0x091B22),
			pink: new Color(0xE7BCF1),
			mint: new Color(0xC7DCD9),
			tan: new Color(0xF1F2EB)
		};

		this.geometry = geometry;

		this.visible = false;

		this.createMaterial();
	}

	/**
	 * Create
	 */

	createMaterial() {
		this.material = new ShaderMaterial({
			depthTest: false,
			depthWrite: false,
			uniforms: {
				u_color: {
					type: 'v3',
					value: this.colors.green
				},
				u_alpha: {
					value: 0
				},
				u_progress: {
					value: 0
				}
			},
			transparent: true,
			fragmentShader,
			vertexShader
		});

		this.scale.set(this.sizes.screen.width, this.sizes.screen.height, this.sizes.screen.width / 2);

		this.position.x = 0;
		this.position.y = 0;
	}

	resize({ sizes }) {
		this.sizes = sizes;
		this.scale.set(this.sizes.screen.width, this.sizes.screen.height, this.sizes.screen.width / 2);
	}

	/**
	 * Animations.
	 */

	change(from, to) {
		return new Promise(resolve => {
			this.colorFrom = this.colors[from];
			this.colorTo = this.colors[to];

			if (!this.isAnimating) {
				this.isAnimating = true;

				this.visible = true;

				this.material.uniforms.u_color.value = this.colorFrom;
				this.position.y = 0;
				this.material.uniforms.u_alpha.value = 1;

				this.timelineOut = gsap.timeline({
					onComplete: () => {
						this.isAnimating = false;
						this.visible = false;
						this.material.uniforms.u_alpha.value = 0;
						this.timelineOut.kill();
						resolve();
					}
				});

				this.timelineOut
					.to(this.position, {
						ease: 'power3.inOut',
						duration: 1,
						y: this.sizes.screen.height
					}, 'start')
					.to(this.material.uniforms.u_progress, {
						ease: 'power3.inOut',
						duration: 0.4,
						value: 1,
						repeat: 1,
						yoyo: true
					}, 'start')
					.call(() => {
						this.setStyle(to);
						document.body.style.transition = 'color 0.25s var(--ease-good) 0.25s';
					}, null, 'start')
					.call(() => {
						document.body.style.transition = '';
					}, null, 'start+=0.5');
			}
		});
	}

	set(from, to) {
		this.colorFrom = this.colors[from];
		this.colorTo = this.colors[to];

		if (!this.isAnimating) {
			this.isAnimating = true;
			this.material.uniforms.u_color.value = this.colorFrom;
			this.setStyle(to, true);
			this.isAnimating = false;
		}
	}

	setStyle(color) {
		document.documentElement.style = `
			--background-color: var(--brand-${color});
			--text-color: var(--brand-${color === 'green' ? 'tan' : 'green'})`;

		document.body.style.transition = 'background-color 0.25s var(--ease-good), color 0.25s var(--ease-good)';
		setTimeout(() => {
			document.body.style.transition = '';
		}, 500);
	}

	/**
	 * Update.
	 */

	/**
	 * Destroy.
	 */

	destroyGeometry() {
		if (this.geometry) {
			this.geometry.dispose();
		}
	}

	destroyMaterial() {
		if (this.material) {
			this.material.dispose();
		}
	}

	destroy() {
		this.destroyGeometry();
		this.destroyMaterial();
	}

}
